import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { VerificationMethodModel } from 'app/model/otp/otp.model';

@Component({
  selector: 'act-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.scss']
})
export class OtpComponent implements OnInit, AfterViewInit {

  private COUNTDOWN_RESEND_OTP = 60;

  public elementId = 'verify-otp';
  public otpInputForm: FormGroup;
  public coundown: number = this.COUNTDOWN_RESEND_OTP;

  @Input() isLoading = false;
  @Input() selectedMethod: VerificationMethodModel;
  @Input() referenceCode: string;
  @Input() error: string;
  @Input() sessionExpired: boolean = false;
  @Output() clickResentOTP: EventEmitter<any> = new EventEmitter();
  @Output() clickVerifyOTP: EventEmitter<string> = new EventEmitter();

  constructor(
    private fb: FormBuilder
  ) {
    this.initialForm();
  }

  ngOnInit(): void {
    this.countdownResentOTP();
  }

  ngAfterViewInit(): void {
    this.focusInput(0);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.referenceCode && changes.referenceCode.currentValue) {
      this.otpInputForm.reset();
    }
  }

  initialForm(): void {
    this.otpInputForm = this.fb.group({
      0: ['', Validators.required],
      1: ['', Validators.required],
      2: ['', Validators.required],
      3: ['', Validators.required],
      4: ['', Validators.required],
    });
    this.otpInputForm.valueChanges.subscribe(() => {
      this.error = undefined;
    });
  }

  get otpControls() {
    return Object.keys(this.otpInputForm.controls);
  }

  countdownResentOTP() {
    this.coundown = this.COUNTDOWN_RESEND_OTP;
    const interval = setInterval(() => {
      if (this.coundown <= 0) {
        clearInterval(interval);
      }
      this.coundown -= 1;
    }, 1000);
  }

  onOtpInput(event: any, index: number) {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.value.length === 1 && index < 4) {
      this.focusInput(index + 1)
    } else if (inputElement.value.length > 1) {
      const value = inputElement.value.slice(0, 1);
      inputElement.value = value;
      this.otpInputForm.controls[index].setValue(value);
    }
  }

  onKeydown(event: KeyboardEvent, index: number) {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Meta', 'Control', 'v'];
    const isNumeric = /^[0-9]$/i.test(event.key);

    if (!isNumeric && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }

    const control = this.otpInputForm.get(index.toString());
    const value = control ? control.value : '';
    if (event.key === 'Backspace' && value !== 0 && !value && index > 0) {
      this.focusInput(index - 1)
    }
  }

  onPaste(event: ClipboardEvent) {
    const clipboardData = event.clipboardData ? event.clipboardData.getData('text') : '';
    if (clipboardData) {
      const pastedOtp = clipboardData.replace(/[^0-9]/g, '');
      const otpChars = pastedOtp.split('');
      otpChars.forEach((char, index) => {
        const control = this.otpInputForm.get(index.toString());
        if (control) {
          control.setValue(char);
        }
      });
      event.preventDefault();
    }
  }

  onClickResendOTP() {
    if (this.coundown <= 0 && !this.sessionExpired) {
      this.countdownResentOTP();
      this.clickResentOTP.emit(this.selectedMethod);
    }
  }

  getOtp() {
    const prefix = "A-";
    const otp = Object.keys(this.otpInputForm.value).map(key => this.otpInputForm.value[key]).join('');
    return `${prefix}${otp}`;
  }

  focusInput(index) {
    const input = document.querySelectorAll(`#${this.elementId}-form input`)[index] as HTMLInputElement;
    if (input) {
      input.focus();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/verify-otp/otp/otp.component.ts